import { PaymentForm } from '../../shop/pages'

export const PayWrapper = () => {
  return <PaymentForm />
}
